import styled from "styled-components";

export const LineChartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
